module.exports = __webpack_public_path__ + "img/franchise_circle_transparent.d1dfe454.svg";